import * as React from "react";
import { useRef } from 'react';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
// import { useForm } from "react-hook-form";
import { Box } from "@mui/system";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import emailjs from 'emailjs-com';

import swal from "sweetalert";
// import emailjs from 'emailjs-com';
import "./contact.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import BackgroundAnimation from "../Home/BackgroundAnimation";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body1,
  padding: theme.spacing(1),
  textAlign: "center",
  color: "white",
  backgroundColor: "transparent !important",
  paddingTop: "5px !important ",
}));
const theme = createTheme();

theme.typography.h3 = {
  fontSize: "28px",
  "@media (min-width:600px)": {
    fontSize: "32px",
  },
};

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('gmailid', 'template_8q5fprn', form.current, 'user_omNKLhkLIkrtoU3I5FntS')
      .then((result) => {
                  swal("Message send", "Well Done!", {
                icon: "success",
                timer: 1300,
              });
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <Box id="contact" sx={{ textAlign: "center", pb: 2 }}>
      <ThemeProvider theme={theme}>
        <Typography
          gutterBottom
          variant="h3"
          component="div"
          sx={{ textAlign: "center", pt: 7 }}
        >
          Contact Me
          <Divider variant="middle" />

        </Typography>
        <form ref={form} onSubmit={sendEmail}>
        {/* <form onSubmit={handleSubmit(onSubmit)}  > */}
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item md={3} sx={{ display: { xs: "none", md: "flex" } }}> <BackgroundAnimation /></Grid>
            <Grid item md={6} sx={{ pb: 2 }}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    margin="normal"
                    // {...register("fullname", { required: true })}
                    fullWidth
                    name="fullname"
                    label="Full Name"
                    type="text"
                    id="fullname"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    // {...register("email", { required: true })}
                    margin="normal"
                    fullWidth
                    id="email"
                    type="email"
                    label="Email Address"
                    name="email"
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    // {...register("message", { required: true })}
                    id="message"
                    label="message"
                    multiline
                    margin="normal"
                    name="message"
                    rows={4}
                    fullWidth
                    type="text"
                    required
                  />
                </Grid>
              </Grid>
              <Button
                className="button-beguni"
                type="submit"
                value="Send"
                fullWidth
                variant="contained"
                sx={{ mt: 1, mb: 6, fontWeight: "bold" }}
              >
                SUBMIT
              </Button>
            </Grid>
            <Grid item md={3} sx={{ display: { xs: "none", md: "flex" } }}> <BackgroundAnimation /></Grid>
          </Grid>
        </form>

       
        <Box sx={{ flexGrow: 1 }} >
          <Grid container spacing={3} >
            <Grid item xs={12} md={3} >
              <Item className="iconhovereffect phonemailsize"   sx={{ boxShadow: 0 }}>Phone: +8801683388762</Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item   sx={{ boxShadow: 0, pt:0 }}>
                <a className="iconhovereffect phonemailsize"  href="mailto:karakib2k18@gmail.com">
                  Email: karakib2k18@gmail.com{" "}
                </a>
              </Item>
            </Grid>
            <Grid item xs={12} md={2}>
             
             </Grid>
            <Grid item xs md={3} >
              <Item className="footericon"  sx={{ boxShadow: 0, pt:0 }} >
                <a
                  href="https://github.com/karakib2k18"
                  target="_blank"
                  rel="noreferrer"
                >
                  <GitHubIcon className="iconhovereffect" sx={{margin: "0px 15px !important", fontSize: "2.2rem" }}/>
                </a>
                <a
                  href="https://www.linkedin.com/in/karakib2k18/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LinkedInIcon className="iconhovereffect"  sx={{margin: "0px 15px !important", fontSize: "2.2rem" }}/>
                </a>
                <a
                  href="https://www.facebook.com/karakib2k18/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FacebookIcon className="iconhovereffect"  sx={{margin: "0px 15px !important", fontSize: "2.2rem" }}/>
                </a>
              </Item>
            </Grid>
            <Grid item xs={12} md={1}>
             
            </Grid>
          </Grid>
        </Box>
        <Typography
          gutterBottom
          variant="body1"
          component="div"
          sx={{ textAlign: "center", pt: 2 }}
          className="iconhovereffect" 
        >
          © All Content reserved by <a href="http://kaziabdurrakib.com">KAZI ABDUR RAKIB</a> 2021
        </Typography>
      </ThemeProvider>
    </Box>
  );
};
export default Contact;
